import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { NavBar } from "./components/NavBar";
import { Home } from "./components/Home";
import { ServiceDetail } from "./components/ServiceDetail";
import { Footer } from "./components/Footer";

function App() {
  return (
    <Router>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <NavBar />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
